import React, { useState } from "react";

const questions = [
  {
    id: 1,
    question: "מה שונה בדאבל בהשוואה לאתרים אחרים?",
    answer: (
      <>
        בדאבל לא מדפדפים בין מאות פרופילים ולא צריכים לחפש לבד. המערכת בודקת
        עבורכם התאמות אישיות לפי ההעדפות שהגדרתם, תוך שמירה על הפרטיות.
        <br />
        בנוסף תמצאו באתר טיפים, רעיונות לדייטים וכלים שיעזרו לכם לאורך הדרך.
      </>
    ),
  },
  {
    id: 2,
    question: "מי יכול לראות את הפרופיל שלי?",
    answer: (
      <>
        הפרופיל שלכם אינו פתוח לדפדוף. רק כאשר נמצאת התאמה, שני הצדדים מקבלים
        גישה לפרטי הפרופיל זה של זו.
        <br />
        כך הפרטים שלכם נשארים פרטיים ואינם מופצים באתר.
      </>
    ),
  },
  {
    id: 3,
    question: "לפי מה נקבעות ההתאמות?",
    answer: (
      <>
        ההתאמות נקבעות לפי הנתונים וההעדפות שהגדרתם, כמו גיל, אזור, סגנון דתי
        ופרטים נוספים.
        <br />
        המערכת מתייחסת גם למה שסיפרתם על עצמכם ולמה שאתם מחפשים בקשר.
      </>
    ),
  },
  {
    id: 4,
    question: "האם שני הצדדים מקבלים את ההתאמה?",
    answer: (
      <>
        כן. ההתאמה נשלחת לשני הצדדים ורק כאשר היא מתאימה להגדרות של שניכם.
        <br />
        אם שניכם מסמנים שתרצו להכיר, המערכת מעדכנת אתכם ומציגה לשניכם את פרטי
        הקשר.
      </>
    ),
  },
  {
    id: 5,
    question: "מה קורה אם לא הגבתי להתאמה בזמן?",
    answer: (
      <>
        ההתאמה מוצגת למשך שבוע, כדי לשמור על תהליך ממוקד ולא להשאיר את הצד השני
        בהמתנה.
        <br />
        אם לא הספקתם להגיב, תוכלו בהמשך לחדש התאמות קודמות ולהציג אותן שוב לצד
        השני.
      </>
    ),
  },
  {
    id: 6,
    question: "מה קורה אם אין התאמה מתאימה כרגע?",
    answer: (
      <>
        זה בהחלט יכול לקרות, במיוחד אם ההעדפות שהוגדרו ממוקדות מאוד. הפרופיל
        שלכם נשמר במערכת, וכשתימצא התאמה מתאימה תקבלו הודעה.
        <br />
        בינתיים הפרטים שלכם נשארים פרטיים ואינם פתוחים לצפייה.
      </>
    ),
  },
  {
    id: 7,
    question: "במה דאבל שונה מהיכרות דרך חברים?",
    answer: (
      <>
        דאבל נבנה כדי לדמות היכרות אישית: במקום לדפדף לבד, המערכת בוחרת התאמות
        ממוקדות ושולחת אותן באופן פרטי.
        <br />
        כך נהנים ממאגר גדול יותר, בלי לוותר על תחושה אישית ומכבדת.
      </>
    ),
  },
  {
    id: 12,
    question: "מה זה דאבליסט ואיך הוא יכול לעזור לי?",
    answer: (
      <>
        דאבליסט הוא אדם שמלווה אתכם בתהליך ההיכרות, כמו חבר או חברה שמכירים אתכם
        ורוצים לעזור.
        <br />
        באישורכם, הדאבליסט יכול לצפות בפרופיל ובהתאמות שלכם, לעזור לדייק את
        הכרטיס, לבחון יחד את ההתאמות שקיבלתם וללוות אתכם לאורך הדרך.
        <br />
        אתם בוחרים מי יהיה הדאבליסט שלכם, ותמיד נשארים בשליטה על המידע שהוא יכול
        לראות.
      </>
    ),
  },
  {
    id: 8,
    question: "אילו כלים נוספים יש באתר?",
    answer: (
      <>
        באתר תמצאו המלצות למקומות ולפעילויות לדייטים, טיפים, מאמרים וכלים לכתיבת
        פרופיל אישי.
        <br />
        המטרה היא לעזור לא רק למצוא התאמה, אלא גם להתקדם בדרך לזוגיות.
      </>
    ),
  },
  {
    id: 9,
    question: "כמה עולה להשתמש בדאבל?",
    answer: (
      <>
        ההרשמה כוללת חודש מנוי במתנה. לאחר מכן ניתן לבחור מסלול מנוי בהתאם
        לאפשרויות המוצגות באתר. נכון לעכשיו המסלול הפופולרי הוא תשלום חד פעמי של
        97 ש"ח לתקופה של חצי שנה .
        <br />
        בחלק מהמקרים ניתן לרכוש מנוי גם באמצעות נקודות שצוברים במערכת.
      </>
    ),
  },
  {
    id: 10,
    question: "למה הקמתם את דאבל?",
    answer: (
      <>
        דאבל נולד מתוך חוויה אישית ורצון ליצור דרך ממוקדת, פרטית ומכבדת יותר
        להכיר.
        <br />
        אנחנו ממשיכים ללמוד מהמשתמשים, לשפר את המערכת ולפתח כלים שיעזרו לאורך
        הדרך. וכן, כבר יצאו מדאבל דייטים, זוגות וגם חתונות.
      </>
    ),
  },
  {
    id: 11,
    question: "יש לדאבל אפליקציה?",
    answer: (
      <>
        כרגע משתמשים בדאבל דרך האתר, והוא מותאם לטלפון.
        <br />
        אפשר להוסיף את האתר למסך הבית וכך לפתוח אותו כמעט כמו אפליקציה. האפשרות
        נמצאת בתפריט הדפדפן תחת „הוספה למסך הבית”.
      </>
    ),
  },
];

const QandA = () => {
  const [openQuestion, setOpenQuestion] = useState(null);

  const toggleQuestion = (questionId) => {
    setOpenQuestion((currentQuestion) =>
      currentQuestion === questionId ? null : questionId,
    );
  };

  return (
    <div className="contactUsHelper qanda-container">
      {questions.map((item) => {
        const isOpen = openQuestion === item.id;

        return (
          <div className="qanda-item" key={item.id}>
            <button
              type="button"
              className={`qanda-question ${isOpen ? "open" : ""}`}
              onClick={() => toggleQuestion(item.id)}
              aria-expanded={isOpen}
            >
              <span>{item.question}</span>

              <span className="qanda-arrow" aria-hidden="true">
                ⌄
              </span>
            </button>

            <div
              className={
                isOpen
                  ? "transition qanda-answer"
                  : "invisible-transition qanda-answer"
              }
            >
              <div className="qanda-answer-content">{item.answer}</div>
            </div>
          </div>
        );
      })}

      <div className="qanda-footer">
        <b>דאבל ממשיך להתפתח</b>
        <div>
          אנחנו קשובים למשתמשים, משפרים את המערכת ומפתחים כלים חדשים שיעזרו
          לאורך הדרך.
        </div>
      </div>
    </div>
  );
};

export default QandA;
